import { Moon, Sun, Monitor } from 'lucide-react'

import { useTheme, type Theme } from '@/contexts/ThemeContext'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const next: Record<Theme, Theme> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
}
const labels: Record<Theme, string> = {
  system: 'Tema do sistema',
  light: 'Tema claro',
  dark: 'Tema escuro',
}

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const Icon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`Alternar tema (atual: ${labels[theme]})`}
          onClick={() => setTheme(next[theme])}
          className="p-2 text-muted-foreground/70 hover:text-muted-foreground transition-colors rounded-lg hover:bg-muted"
        >
          <Icon className="h-5 w-5" />
        </button>
      </TooltipTrigger>
      <TooltipContent>
        {labels[theme]} (clique para alternar)
      </TooltipContent>
    </Tooltip>
  )
}

